import React from 'react'
import { Wrapper, Paragraph } from './styles'

export function Notification({classes, message, id}) {
  return <Wrapper id={id} className={`notification ${classes}`}>
    <Paragraph>{message}</Paragraph>
  </Wrapper>
}
